export function formatValue(value, precision = 2, unit = '') {
  if (!Number.isFinite(value)) return '—';
  const text = Number(value.toFixed(precision)).toString();
  return unit ? `${text} ${unit}` : text;
}

export function formatSigned(value, precision = 2) {
  if (!Number.isFinite(value)) return '—';
  const text = formatValue(value, precision);
  return value > 0 ? `+${text}` : text;
}

export function formatClock(seconds) {
  if (!Number.isFinite(seconds)) return '00:00.0';
  const safe = Math.max(0, seconds);
  const minutes = Math.floor(safe / 60);
  const rest = safe - minutes * 60;
  return `${String(minutes).padStart(2, '0')}:${rest.toFixed(1).padStart(4, '0')}`;
}

export function formatExponential(value, digits = 2) {
  if (!Number.isFinite(value)) return '—';
  if (value === 0) return '0';
  return value.toExponential(digits).replace('e-', '×10⁻').replace('e+', '×10⁺');
}

export function formatPercent(value, digits = 2) {
  if (!Number.isFinite(value)) return '—';
  return `${(value * 100).toFixed(digits)}%`;
}

export function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

export function classNames(...values) {
  return values.filter(Boolean).join(' ');
}

export function paramsFingerprint(params) {
  return Object.keys(params)
    .sort()
    .map((key) => `${key}:${params[key]}`)
    .join('|');
}
